// Carry Roll Collapsible — shared collapsible section container.

import { useState, type ReactNode } from 'react';
import { ChevronDown } from 'lucide-react';

interface CollapsibleProps {
  title: string;
  children: ReactNode;
  defaultOpen?: boolean;
  testId?: string;
  helpLabel?: string;
}

export function Collapsible({ title, children, defaultOpen = true, testId, helpLabel }: CollapsibleProps) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section
      className="panel"
      data-testid={testId}
      aria-label={helpLabel ?? title}
    >
      <button
        type="button"
        className="flex w-full items-center justify-between bg-transparent"
        style={{ border: 'none', cursor: 'pointer', padding: 0 }}
        aria-expanded={open}
        aria-controls={`${testId ?? title}-content`}
        onClick={() => setOpen((o) => !o)}
      >
        <span className="subsection-title" style={{ marginBottom: 0 }}>
          {title}
        </span>
        <ChevronDown
          size={20}
          aria-hidden="true"
          style={{ transform: open ? 'rotate(0deg)' : 'rotate(-90deg)', transition: 'transform var(--motion-med)' }}
        />
      </button>
      {open && (
        <div id={`${testId ?? title}-content`} className="mt-3" style={{ display: 'grid', gap: 'var(--gap-input)' }}>
          {children}
        </div>
      )}
    </section>
  );
}
